<template>
    <div class="space-y-4">
        <div v-for="teacher in teachers" class="rounded-2xl border-1 border-slate-300 p-4 space-y-4">
            <div class="flex gap-4 items-center">
                <img :src="teacherImagePath + (teacher.image_url || 'ansatte-placeholder.png')" :alt="teacher.call_name + ' ' + teacher.last_name + ' ' + $t('bilde')" class="w-12 h-12 rounded-full object-cover border border-slate-200" />
                <div class="flex flex-col">
                    <div class="text-lg font-bold">{{ teacher.call_name }} {{ teacher.last_name }}</div>
                    <div class="flex items-center gap-4">
                        <div v-if="teacher.mobile" class="flex items-center gap-1 text-sm text-neutral-600">
                            <Phone :size="14" :strokeWidth="2" /><a :href="'tel:' + teacher.mobile">{{ teacher.mobile }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-sm gap-2 flex flex-col">
                <div v-for="slot in teacher.slots" class="rounded-2xl border-1 border-slate-300 p-4 font-regular flex justify-between items-center" @click="openBookingModal(slot, teacher.user_id)">
                    <div>
                        {{ currentProduct.product_name }} <span v-if="slot.quantity > 1">x{{ slot.quantity }}</span>
                        ({{ slot.class_short_name }})
                    </div>
                    <div>{{ slot.start_time }} - {{ slot.end_time }}</div>
                    <div>{{ priceFormat(slot.price * slot.quantity) }}</div>
                    <div class="bg-primary px-4 py-2 text-white rounded-xl cursor-pointer">{{ $t('Bestill') }}</div>
                </div>
                <!-- <div class="text-sm text-neutral-600" v-if="slot.location">
                    {{ slot.location }}
                </div> -->
            </div>
        </div>
    </div>
</template>

<script setup>
    import { Phone, Mail } from "lucide-vue-next"

const {currentProduct} = defineProps({
    teachers: {
        type: Array,
        required: true
    },
    teacherImagePath: {
        type: String,
        required: true
    },
    currentProduct: {
        type: Object,
        required: true
    }
});


function openBookingModal(slot, teacherId) {
    console.log(slot)

    TABS.api.loadLesson(slot.class_id, currentProduct.product_id, teacherId, slot.start, slot.end, TABS.api.officeId )
}

function priceFormat(price) {
    return price ? window.TABS.L10n.money.parse(price).format() : '';
}
</script>